import React from 'react';

export function ResetCodeInput({value, onChange, disabled}) {
  const inputs = React.useRef([]);
  const digits = Array.from({length: 6}, (_, index) => /\d/.test(value[index] || '') ? value[index] : '');
  const focus = index => inputs.current[Math.max(0, Math.min(5, index))]?.focus();
  const update = next => onChange(next.map(digit => digit || ' ').join('').trimEnd());
  const insert = (index, text) => {
    const incoming = text.replace(/\D/g, '').slice(0, 6);
    const start = incoming.length === 6 ? 0 : index;
    const next = [...digits];
    if (!incoming) next[index] = '';
    else for (let offset = 0; offset < incoming.length && start + offset < 6; offset++) next[start + offset] = incoming[offset];
    update(next);
    if (incoming) focus(start + incoming.length);
  };
  return <div className="reset-code-digits" role="group" aria-labelledby="reset-code-label">
    {digits.map((digit, index) => <input key={index} ref={element => {inputs.current[index] = element;}}
      className="browser-default" id={index === 0 ? 'reset-code' : undefined}
      aria-label={`Číslice ${index + 1} z 6`} type="text" inputMode="numeric"
      autoComplete={index === 0 ? 'one-time-code' : 'off'} maxLength={6} pattern="[0-9]" required
      value={digit} disabled={disabled} autoFocus={index === 0}
      onFocus={event => event.target.select()}
      onChange={event => insert(index, event.target.value)}
      onPaste={event => {event.preventDefault(); insert(index, event.clipboardData.getData('text'));}}
      onKeyDown={event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {event.preventDefault(); focus(index + (event.key === 'ArrowLeft' ? -1 : 1));}
        if (event.key === 'Backspace' && !digit && index > 0) {
          event.preventDefault(); const next = [...digits]; next[index - 1] = ''; update(next); focus(index - 1);
        }
      }}/>) }
  </div>;
}
